module.exports = __webpack_public_path__ + "static/media/checkreleased.27ec9b5a.png";